import React, { Component } from "react";
import ListDataView from "../DataView/ListDataView";
import Strings from "@my-dld/assets/strings";
import { LocaleUtil } from "@eres/core";
import { DataTableLang } from "@my-dld/utils/DataTableUtils";
import { ValuationRequest } from "../../valuationapi/entities";
import { getEVReqCommitteeStatus, getEVReqNo } from "@my-dld/screens/MyDLD/MyRequest/ExternalValuationRequests";

export interface EVReqProps {
	items: ValuationRequest[];
	onDetails: ( req: ValuationRequest ) => void;
}

class EVRequestsListView extends Component<EVReqProps> {
	componentDidMount(): void {
		this.configDataTable();
	}

	render() {
		const { items, onDetails } = this.props;
		return <ListDataView
			items={ items }
			renderListHeader={ () => {
				return <RenderHeader/>;
			} }
			renderListItem={ ( item: ValuationRequest ) => {
				return <RenderListItem
					key={ item.requestNumber }
					item={ item }
					onDetails={ onDetails }/>;
			} }/>;
	}

	private configDataTable = () => {
		try {
			window.$( "#ListView" ).DataTable( {
				language: LocaleUtil.Select( DataTableLang ),
				responsive: false,
				lengthChange: false,
				scrollX: true
			} );
		} catch ( e ) {
			console.warn( "Data table unavailable", e );
		}
	};
}

function RenderHeader() {
	return <tr>
		<th>{ Strings.request_number }</th>
		<th>{ Strings.request_status }</th>
		<th>{ " " }</th>
	</tr>;
}

function RenderListItem( props: { item: ValuationRequest, onDetails: ( request: ValuationRequest ) => void } ) {
	const { item, onDetails } = props;
	return <tr data-item={ JSON.stringify( item ) } className="clickable-row">
		<td data-label={ Strings.request_number }>{ getEVReqNo( item ) }</td>
		<td data-label={ Strings.request_status }>{ getEVReqCommitteeStatus( item ) }</td>
		<td className="text-center">
			<span className="table-view-detail-link"> { Strings.view_details } </span>
			<i className="far fa-arrow-alt-circle-right"/>
		</td>
	</tr>;
}

export default EVRequestsListView;
